import React from 'react';
import styles from './ThankYou.module.css';
import { useAppSelector } from '../../../store/hooks';
import { selectAppParentPortalData } from '../../../store/reducer/appParentPortalDataSlice';
import { selectAppUserProfile } from '../../../store/reducer/appStateSlice';
import { ThankYouElement } from '../ThankYouElement';

export const DesktopView = (): JSX.Element => {
  // REDUX
  const appParentPortalData = useAppSelector(selectAppParentPortalData);
  const userProfileData = useAppSelector(selectAppUserProfile);

  const thankYouElement = ThankYouElement();
  return (
    <React.Fragment>
      <div className={styles.thankYouDesktop}>
        <img
          className={styles.desktopThankYouHeaderIcon}
          id="desktop-thank-you-header"
          alt=""
          src="assets/thankYou/desktop-thank-you-header.svg"
        />
        <img
          className={styles.desktopSubscriptionFooterIcon}
          id="desktop-subscription-footer"
          alt=""
          src="assets/common/desktop-subscription-footer.svg"
        />
        <section
          className={styles.thankYouMainGroupSection}
          id="thank-you-main-group"
        >
          <div className={styles.thankYouMainGroupContentBDiv}>
            <div className={styles.thankYouMainGroupContentGDiv}>
              <div className={styles.thankYouMainGroupContentGDiv1}>
                <div className={styles.thankYouMainGroupContentGDiv2}>
                  <div className={styles.groupDiv}>
                    <img
                      className={styles.thankYouMainGroupContentGIcon}
                      id="thank-you-main-group-content-group-thank-you-image"
                      alt=""
                      src="assets/thankYou/thank-you-main-group-content-group-thank-you-image@3x.png"
                    />
                    <div className={styles.paymentSuccessfulDiv}>
                      Payment Successful!
                    </div>
                  </div>
                  <div className={styles.thankYouMainGroupContentGDiv3} />
                </div>
              </div>
              <div className={styles.thankYouMainGroupContentGDiv4}>
                <div className={styles.thankYouMainGroupContentGDiv5}>
                  <section
                    className={styles.thankYouMainGroupContentGSection}
                    id="thank-you-main-group-content-group-content-transaction-detail-left"
                  >
                    <div className={styles.summaryDiv}>
                      <div className={styles.frameDiv}>
                        <div className={styles.yourSummaryDiv}>
                          Your Summary
                        </div>
                        <div className={styles.emailDiv}>
                          <section className={styles.frameSection}>
                            <img
                              className={styles.thankYouTransactionIcon}
                              id="thank-you-transaction-icon"
                              alt=""
                              src="assets/thankYou/thank-you-transaction-icon.svg"
                            />
                            <div className={styles.frameDiv2}>
                              <div
                                className={styles.thankYouMainGroupContentGDiv6}
                              >
                                {thankYouElement.subscriptionPlanLabel}
                              </div>
                              <div
                                className={styles.thankYouMainGroupContentGDiv7}
                              >
                                {thankYouElement.getSubscriptionPlanSubLabel(
                                  (appParentPortalData.paymentRecord
                                    ?.payment_detail.payment_to ??
                                    '') as string,
                                )}
                              </div>
                              <div className={styles.frameDiv3}>
                                <div className={styles.frameDiv4}>
                                  <div className={styles.frameDiv5}>
                                    <div className={styles.levelDiv}>Level</div>
                                    <div
                                      className={
                                        styles.thankYouMainGroupContentGDiv8
                                      }
                                    >
                                      {thankYouElement.subscriptionLevel(
                                        userProfileData,
                                      )}
                                    </div>
                                  </div>
                                </div>
                                <div className={styles.frameDiv4}>
                                  <div className={styles.frameDiv5}>
                                    <div className={styles.levelDiv}>Date</div>
                                    <div
                                      className={
                                        styles.thankYouMainGroupContentGDiv8
                                      }
                                    >
                                      {thankYouElement.subscriptionDate}
                                    </div>
                                  </div>
                                </div>
                                <div className={styles.frameDiv4}>
                                  <div className={styles.frameDiv5}>
                                    <div className={styles.levelDiv}>
                                      Amount
                                    </div>
                                    <div
                                      className={
                                        styles.thankYouMainGroupContentGDiv8
                                      }
                                    >
                                      {/* {thankYouElement.subscriptionPlanPrice} */}
                                      {`HKD $${
                                        (appParentPortalData.paymentRecord
                                          ?.payment_response
                                          ?.amount_total as number) / 100
                                      }`}
                                    </div>
                                  </div>
                                </div>
                                <div className={styles.frameDiv4}>
                                  <div className={styles.frameDiv5}>
                                    <div className={styles.levelDiv}>
                                      Transfer Method
                                    </div>
                                    <div
                                      className={
                                        styles.thankYouMainGroupContentGDiv8
                                      }
                                    >
                                      {/* {thankYouElement.subscriptionMethod} */}
                                      {`${
                                        appParentPortalData.paymentRecord
                                          ?.payment_response
                                          .payment_method_types as string[][0]
                                      }`}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </section>
                        </div>
                      </div>
                    </div>
                  </section>
                  <section
                    className={styles.thankYouMainGroupContentGSection1}
                    id="thank-you-main-group-content-group-content-transaction-deta-right"
                  >
                    <div className={styles.notesDiv}>Notes</div>
                    <div className={styles.emailDiv}>
                      <div className={styles.frameDiv12}>
                        <img
                          className={styles.thankYouTransactionIcon}
                          id="thank-you-email-icon"
                          alt=""
                          src="assets/thankYou/thank-you-email-icon.svg"
                        />
                        <div className={styles.frameDiv2}>
                          <div className={styles.emailInstructionsDiv}>
                            Email Instructions
                          </div>
                          <div className={styles.pleaseCheckYourEmailForFu}>
                            Please check your email for further instructions on
                            how to best experience Big Bang Lab.
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className={styles.emailDiv}>
                      <div className={styles.frameDiv12}>
                        <img
                          className={styles.thankYouTransactionIcon}
                          id="thank-you-box-icon"
                          alt=""
                          src="assets/thankYou/thank-you-box-icon.svg"
                        />
                        <div className={styles.frameDiv2}>
                          <div className={styles.emailInstructionsDiv}>
                            Experiment Box
                          </div>
                          <div
                            className={styles.pleaseCheckYourEmailForFu}
                          >{`The first experiment box will be sent to your address in 3-5 working days.  `}</div>
                        </div>
                      </div>
                    </div>
                  </section>
                </div>
                <div
                  className={styles.thankYouMainGroupContentGButton}
                  id="thank-you-main-group-content-group-content-button"
                >
                  {thankYouElement.startBigBangLabButton}
                </div>
              </div>
            </div>
          </div>
          <img
            className={styles.thankYouMainGroupIcon}
            id="thank-you-main-group-icon"
            alt=""
            src="assets/thankYou/thank-you-main-group-icon.svg"
          />
        </section>
      </div>
    </React.Fragment>
  );
};
